import React from 'react';

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import { AmContainer } from '../../controls';

import { SignIn, SignUp, ForgotPassword, ForgotPasswordSent } from '.';

import { Http404, PrivacyPolicy, Tos } from '../../shared';

const Unauthorized = () => {
  return (
    <div className="App">
      <header className="App-header">
        <AmContainer>
          <Router>
            <Switch>
              <Route exact path="/sign-in" component={SignIn} />
              <Route exact path="/forgot-password" component={ForgotPassword} />
              <Route exact path="/tos" component={Tos} />
              <Route exact path="/privacy-policy" component={PrivacyPolicy} />
              <Route
                exact
                path="/forgot-password-sent"
                component={ForgotPasswordSent}
              />
              <Route exact path="/sign-up" component={SignUp} />
              <Redirect from="/" to="/sign-in" />
              <Route exact path="*" component={Http404} />
            </Switch>
          </Router>
        </AmContainer>
      </header>
    </div>
  );
};

export { Unauthorized };
